module.exports = __webpack_public_path__ + "img/fig_003.801d190e.png";